import React from 'react'
import './invite-students-v2.scss'
import SessionCache from '../../routes/session-cache'
import { Modal, ModalBody } from 'reactstrap'
import { Constants, ImageConstants } from '../../../constants/constants'
import { getImageSource } from '../../../utility/image-source'
import ToasterComponent from '../../common/cw-toaster-component/cw-toaster-component'
import CommonUtils from '../../../utility/common-utilities'
import SchoolApi from '../../../apis/school'
import Dropdown from '../../common/dropdown-v2/dropdown'
import CommonApi from '../../../apis/common'
import moment from 'moment'

class InviteStudentsV2 extends React.Component {
  state = {
    mobileNumber: '',
    email: '',
    isWhatsappInvited: false,
    countryCodeDropdown: []
  }

  constructor(props) {
    super(props)
    let user = SessionCache.getUser()
    this.user = user
    this.state.teachers = [
      { mobileNumber: user.mobileNumber, countryCode: user.countryCode }
    ]
    this.state.fromEvents = this.props.fromEvents

    this.getCountryCodes()
  }

  getCountryCodes(payload = {}) {
    CommonApi.getCountryCodeList(payload)
      .then(response => {
        let data = response.response
        if (data.length) {
          this.setState({ countryList: data })
          let countryCodeDropdown = this.buildCountryCodeDropdown(data)
          this.setState({ countryCodeDropdown })
        }
      })
      .catch(err => { })
  }

  buildCountryCodeDropdown(list = []) {
    let countryCodeDropdown = []
    let countryCodeHash = {}
    for (let i = 0; i < list.length; i++) {
      let item = list[i]

      if (!countryCodeHash[item.dialCode]) {
        countryCodeHash[item.dialCode] = item
        countryCodeDropdown.push({
          title: `${item.name} ${item.dialCode}`,
          value: item.dialCode
        })
      }
    }
    this.setState({ hashedCountryCode: countryCodeHash })
    return countryCodeDropdown
  }

  onCountryCodeSearch(value, index) {
    if (value.length > 2 || !value) {
      this.countryCodeIndex = index
      this.getCountryCodes({ name: `/${value}` })
    }
  }

  convertDate = (date, currentFormat = '', requiredFormat = 'DD MMM YYYY') => {
    return moment(date, currentFormat).format(requiredFormat)
  }

  onSelectCountryCode(option, index) {
    const { teachers } = this.state
    const countryCode = option?.value
    teachers[index].countryCode = countryCode
    this.setState({ teachers })
  }

  showToaster(type, message) {
    this.setState(
      {
        showToaster: true,
        toasterMessage: message,
        toasterType: type
      },
      () => {
        setTimeout(() => {
          this.hideToaster()
        }, 3000)
      }
    )
  }

  hideToaster() {
    this.setState({
      showToaster: false
    })
  }

  getInitDate(startTime) {
    let initDate = ""
    if (new Date(startTime) < new Date()) {
      initDate = `Open Now - Start at the earliest`
    } else {
      initDate = this.convertDate(startTime, 'YYYY-MM-DD hh:mm:ssZ', "hh:mm A, Do MMM YYYY")
    }
    return initDate
  }

  getFinalDate(startTime, endTime) {
    return `${moment(startTime).format("h:mm A")} - ${moment(endTime).format("h:mm A")} IST, ${moment(endTime).format("Do MMMM")}`
  }

  copyLink = _ => {
    var dummy = document.createElement('textarea')
    // dummy.style.display = 'none'
    document.body.appendChild(dummy)
    if (this.state.fromEvents) {
      const event = this.props.event

      let initDate = this.getInitDate(event?.step1?.startTime)

      let finalDate = this.getFinalDate(event?.step3?.startTime, event?.step3?.endTime)
      // ${event?.notificationTitle}
      dummy.value = `Dear Students,

      This is an invitation to participate in *${event.title}*. Our school has signed up to participate in this event.
      
      ⛳Eligibility: Students of Classes Class 6 to Class 9
      
      🎯How to Participate: 
      1. Login to the Countingwell App
      2. Go to My Profile on the Countingwell app and the enter the school code:  ${this.user.schoolInfo.schoolCode}
      3. Tap on the *${event.title}* card and follow further instructions from there.
      
      Note: If you do not have the app, you can download it by going to this link: ${'https://t2m3p.app.link/idcLs5rNInb?schoolCode=' +
        this.user.schoolInfo.schoolCode}
      
      🗓Dates: 
      
      Initial Test Content: *${event?.initalDateText}*
      Final Test: *${event?.finalDateText}*
      
      All the best.`
    } else {
      dummy.value = `Dear Student,

      ${this.user.schoolInfo.name} has started using Countingwell for assigning and managing your Maths homework. Hereafter, we will start assigning you homework, tests and revision/practice tests through the Countingwell mobile app.
      
      
      ⛳Instruction:
      
      1. Download the Countingwell App from this link: ${'https://t2m3p.app.link/idcLs5rNInb?schoolCode=' +
        this.user.schoolInfo.schoolCode}
        2. Register on the app or login if you have already registered
        3. Go to My Profile on the Countingwell app and the enter the school code: ${this.user.schoolInfo.schoolCode}
        4. Tap on My Homeworks card on the Countingwell app to see the list of your assigned homework and start completing the homework.  

      Download the Countingwell app from the above link, sign up and confirm.

      From Management,
      ${this.user.schoolInfo.name}`
    }
    dummy.select()
    document.execCommand('copy')
    document.body.removeChild(dummy)
    this.showToaster('info', 'Copied')
  }

  onChangeMobile = (event, key, index) => {
    const { teachers } = this.state
    const mobileNumber = event.target.value

    teachers[index].mobileNumber = mobileNumber
    this.setState({ teachers })
  }

  validateAllMobileNumbers = () => {
    const { teachers } = this.state
    let isValid = true
    for (let i = 0; i < teachers.length; i++) {
      const teacher = teachers[i]
      const mobileNumber = teacher.mobileNumber
      const countryCode = teacher.countryCode
      const countryCodeDetail = this.state.hashedCountryCode[countryCode]
      const validateCountryCode = CommonUtils.validateMobileNumber(
        mobileNumber,
        countryCodeDetail
      )
      if (!validateCountryCode) {
        teacher.isInvalidMobile = true
        teachers[i] = teacher
        this.setState({ teachers })
        isValid = false
      } else {
        teacher.isInvalidMobile = false
        teachers[i] = teacher
        this.setState({ teachers })
      }
      if (i === teachers.length - 1) return isValid
    }
  }

  allowEdit = key => {
    this.setState({
      ['allow' + key]: true,
      ['disable' + key]: true
    })
  }

  onContinue = _ => {
    this.props.onContinue()
  }

  sendInvitation = _ => {
    const { teachers } = this.state
    const isValid = this.validateAllMobileNumbers()
    if (!isValid) return
    const { event } = this.props
    let payload = {
      teachers,
      schoolCode: this.user.schoolInfo.schoolCode,
      adminName: this.user.name,
      schoolName: this.user.schoolInfo?.name,
      // eventName: event?.notificationTitle,
      eventName: `${event?.title}`,
      initialDate: `*${event?.initalDateText}*`,
      finalDate: `*${event?.finalDateText}*`,
      isExistingTemplate: this.state.fromEvents,
      eligibleClasses: `Class 6 to Class 9`
    }
    this.setState({
      isInviteSubmit: true
    })
    SchoolApi.sendStudentInvitations(payload)
      .then(response => {
        this.setState({ teachers: [] }, _ => {
          this.setState({
            isInviteSubmit: false,
            teachers: [
              {
                mobileNumber: this.user.mobileNumber,
                countryCode: this.user.countryCode
              }
            ]
          })
        })
        // this.props.onClose(true)
        this.showToaster('info', 'Message shared successfully on Whatsapp')
      })
      .catch(err => {
        this.showToaster('error', 'Something went wrong')
        this.setState({
          isInviteSubmit: false
        })
      })
  }

  removeTeacher = index => {
    const { teachers } = this.state
    teachers.splice(index, 1)
    this.setState({
      teachers
    })
  }

  addNewTeacher = _ => {
    const { teachers } = this.state
    teachers.push({ mobileNumber: '', countryCode: '+91' })
    this.setState({
      teachers
    })
  }

  render() {
    const {
      toasterMessage,
      toasterType,
      isInviteSubmit,
      showToaster,
      countryCodeDropdown,
      teachers
    } = this.state
    return (
      <Modal
        className='cw-custom-modal custom-toaster-modal invite-students-v2'
        isOpen={true}
        toggle={this.props.onClose}
        size={'md'}
      >
        <ModalBody>
          <div className=''>
            <div className='pt-1 pb-2'>
              <span className='text-right'>
                <img
                  className='close-icon cursor-pointer'
                  src={getImageSource(ImageConstants.CROSS)}
                  onClick={this.props.onClose}
                />
              </span>
            </div>
            <div>
              <div className='invite-students-container'>
                <div className='row'>
                  <div className='col'>
                    <div className='text-center'>
                      <strong className='header-text'>
                        SHARE THE INVITE WITH STUDENTS
                      </strong>
                      <div className='header-description'>
                        and ask them to follow the on-screen instructions to
                        create their own accounts and join the countingwell
                        platform.
                      </div>
                    </div>
                    <div className='separator'>
                      <img src={getImageSource(ImageConstants.SEPARATOR)} />
                    </div>
                    <div className='share-container mt-2 my-2'>
                      <div className='share-left'>
                        <div className='step'>1</div>
                      </div>
                      <div className='share-right'>
                        <div className='title'>COPY & SHARE</div>
                        <div className='description'>
                          Copy the link below and paste it in an email or
                          WhatsApp and share with Students
                        </div>
                      </div>
                    </div>
                    <div className='copy-container'>
                      <div className='share-link'>
                        https://t2m3p.app.link/idcLs5rNInb
                      </div>
                      <div
                        className='copy-button cursor-pointer'
                        onClick={this.copyLink}
                      >
                        <img src={getImageSource(ImageConstants.CLONE_WHITE)} />{' '}
                        <span>COPY</span>
                      </div>
                    </div>
                    <div className='separator'>
                      <img src={getImageSource(ImageConstants.SEPARATOR)} />
                      <span className='separator-text'>OR</span>
                    </div>
                    <div className='share-container mt-2 my-2'>
                      <div className='share-left'>
                        <div className='step'>2</div>
                      </div>
                      <div className='share-right'>
                        <div className='title'>INSTANT SHARE ON WHATSAPP</div>
                        <div className='description'>
                          Send to yourself by entering your number and forward
                          the message to other students from your own WhatsApp
                          number.
                        </div>
                      </div>
                    </div>
                    {teachers.map((teacher, index) => (
                      <>
                        <div className='input-container' key={index}>
                          <div
                            className={`input-box d-inline-block  ${teacher.isInvalidMobile && teacher.mobileNumber
                              ? 'invalid'
                              : ''
                              }`}
                          >
                            {countryCodeDropdown?.length && (
                              <div className='cw-country-code d-inline-block'>
                                <Dropdown
                                  key='countryCode'
                                  placeholder='Search country code'
                                  options={countryCodeDropdown}
                                  onSelect={option =>
                                    this.onSelectCountryCode(option, index)
                                  }
                                  text='title'
                                  onSearch={value =>
                                    this.onCountryCodeSearch(value)
                                  }
                                  style={{ background: '#F6F7F5' }}
                                  value={teacher.countryCode}
                                />
                              </div>
                            )}
                            <span className='cw-separator'></span>
                            <input
                              className={`cw-mobile-number cw-input-left`} //${!allowmobileNumber&& 'not-editable'}
                              placeholder='Enter Mobile Number'
                              value={teacher.mobileNumber}
                              onChange={e =>
                                this.onChangeMobile(e, 'mobileNumber', index)
                              }
                            />
                          </div>
                          {index > 0 && (
                            <div className='delete-container'>
                              <img
                                className='close-icon cursor-pointer'
                                onClick={_ => this.removeTeacher(index)}
                                src={getImageSource(ImageConstants.DELETE_RED)}
                              />
                            </div>
                          )}
                        </div>
                        <div className='col'>
                          {teacher.isInvalidMobile && (
                            <span className='invalid-text'>
                              Enter valid phone number
                            </span>
                          )}
                        </div>
                      </>
                    ))}
                    <div className='add-teacher text-right'>
                      <span
                        className='cursor-pointer'
                        onClick={this.addNewTeacher}
                      >
                        + ADD WHATSAPP NO
                      </span>
                    </div>
                    <div className='mt-2 text-center'>
                      {!isInviteSubmit && (
                        <button
                          className={
                            !isInviteSubmit
                              ? 'cw-button-primary cw-button-mod'
                              : 'cw-button-disabled'
                          }
                          onClick={() =>
                            !isInviteSubmit && this.sendInvitation()
                          }
                        >
                          <img
                            src={getImageSource(ImageConstants.WHATSAPP_WHITE)}
                          />{' '}
                          <span>SHARE</span>
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {showToaster ? (
                <ToasterComponent
                  message={toasterMessage}
                  type={toasterType}
                  position='bottom-center'
                />
              ) : (
                ''
              )}
            </div>
          </div>
        </ModalBody>
      </Modal>
    )
  }
}

export default InviteStudentsV2
